import { 
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
} from "@material-ui/core"

import React, { Component } from "react"

/**
 * События элемента
 * 
 * onAddShopClick(shop) - запрос на добавление магазина. Вызывается когда вся нужная информация о магазине введена 
 * и нажата кнопка добавить. Переменная shop содержит информацию о добавляемом магазине.
 * 
 * onCancelClick() - запрос отмены добавления магазина.
 */

class AddShopDialog extends (Component) {

    constructor(props) {
        
        super(props)
        
        this.state = {
            name: "",
            dialog: undefined,
        }

    }

    readyToAdd() {
        if (this.state.name === "") {
            return false
        }
        return true
    }

    render() {

        if (this.state.dialog) {
            return this.state.dialog
        }

        return <Dialog
            open = {true}
            fullWidth = {true}        
        >

            <DialogTitle>
				Добавить магазин
			</DialogTitle>

            <DialogContent style = {{display: "flex", flexDirection: "column"}}>
                
                <TextField
					value = {this.state.name}
					label = "Название магазина"
					margin = "normal"
					onChange = {e => {
						e.preventDefault()
						this.setState({name: e.target.value})
					}}                    
                />

            </DialogContent>

            <DialogActions>

                <Button
                    disabled = {!this.readyToAdd()}
                    onClick = {e => {
                        e.stopPropagation()
                        if (typeof this.props.onAddShopClick === "function") {
                            this.props.onAddShopClick({
                                name: this.state.name,
                            })
                        }
                    }}
                >Добавить</Button>

                <Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancelClick === "function") {
							this.props.onCancelClick()
						}
					}}
				>Отмена</Button>

            </DialogActions>

        </Dialog>

    }

}

export default AddShopDialog